<template>
  <div id="app" class="page-wrapper">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'app',
  data() {
    return {
        authenticated: false,
        authUserData: null,
    }
  },
  mounted() {
    if( !this.isAuth() && this.$router.currentRoute.name != "login" )
      this.$router.replace({ name: "login" })

    if( this.isAuth() && this.$router.currentRoute.name == "login" )
      this.$router.replace({ name: "system" })
  }
}
</script>
<style>
* { box-sizing: border-box; }

body { background: #f7f7f7; }
body { font-family: "Poppins", sans-serif !important; font-size: 12px !important; color: #272727 !important; line-height: 14px !important; }
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
.wrapper { margin: 0 22px; }
#content { margin: 0; padding-bottom: 20px; padding-top: 50px; position: relative; }
ul, ul li { list-style: none; padding: 0; margin: 0; }

.vue-recycle-scroller.direction-vertical:not(.page-mode) { overflow-y: scroll !important; }

.md-overlay { z-index: 100000 !important; }
.md-dialog { z-index: 100001 !important; }

.ui.selection.dropdown { padding: 0.6em 2.1em 0.6em 1em; font-size: 12px; }
.ui.selection.dropdown .menu>.item { font-size: 12px; }

select.form-control:not([size]):not([multiple]) { height: 33px; }
.form-control { font-size: 12px; }

.small-dialog { 
  width: 1000px;
  max-width: 80%;
  overflow: auto;
  height: auto;
}

/* Animation */
.menu-fade-enter {
  opacity: 0;
  width: auto;
}

.menu-fade-enter-active {
  transition: .8s;
}

.menu-fade-enter-to {
  width: auto;
}

.menu-fade-leave {
  width: 60px;
}

.menu-fade-leave-to {
  width: 0px;
  opacity: 0;
}

.menu-fade-leave-active {
  transition: all .8s;
  
}

</style>
